import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import { TipoView } from '../interfaces/organizacao.interface';
import { logger } from '../utils/console';

@Injectable({
  providedIn: 'root'
})
export class RolesManagerService {
  navigation: any;

  constructor(
    private _fuseConfig: FuseConfigService,
    private router: Router
  ) { }

  async SetarAmbiente(tipo_acesso: TipoView) : Promise<string | null> {
    logger.log('[RolesManager] Configurando ambiente para:', tipo_acesso);
    
    if (tipo_acesso && tipo_acesso !== 'super' && tipo_acesso !== 'admin') {
      const temas = {
        enfermeiro: { 
          colorTheme: 'theme-enfermeiro', 
          layout: { 
            navbar: { secondaryBackground: 'fuse-navy-A400', hidden: false }, 
            toolbar: { background: 'fuse-navy-A400', hidden: false }
          }
        },
        medico: { 
          colorTheme: 'theme-medico', 
          layout: { 
            navbar: { secondaryBackground: 'fuse-navy-A400', hidden: false }, 
            toolbar: { background: 'fuse-navy-A400', hidden: false }
          }
        },
        secretaria: { 
          colorTheme: 'theme-secretaria', 
          layout: { 
            navbar: { secondaryBackground: 'fuse-navy-A400', hidden: false }, 
            toolbar: { background: 'fuse-navy-A400', hidden: false }
          }
        },
        paciente: { 
          colorTheme: 'theme-paciente', 
          layout: { 
            navbar: { secondaryBackground: 'fuse-navy-A700', hidden: false }, 
            toolbar: { background: 'fuse-navy-A700', hidden: false }
          }
        },
        webview: { 
          colorTheme: 'theme-webview', 
          layout: { 
            navbar: { secondaryBackground: 'fuse-navy-A700', hidden: true }, 
            toolbar: { background: 'fuse-navy-A700', hidden: true }
          }
        },
      };

      const tema = temas[tipo_acesso];
      
      if (!tema) {
        logger.error('[RolesManager] Tema não encontrado para tipo:', tipo_acesso);
        this.router.navigateByUrl(`/auth/blocked`);
        return null;
      }

      // Aplica o tema - FuseConfigService atualiza reativamente a UI
      this._fuseConfig.config = tema;
      logger.log('[RolesManager] Tema aplicado:', tema.colorTheme);

      // Navega para a rota do tipo de usuário
      this.router.navigate([`/${tipo_acesso}`], { queryParamsHandling: 'preserve' });
      logger.log('[RolesManager] Navegando para:', `/${tipo_acesso}`);
      
      return 'sucesso'; 
    } else {
      logger.warn('[RolesManager] Acesso bloqueado para tipo:', tipo_acesso);
      this.router.navigateByUrl(`/auth/blocked`); 
      return null; 
    }

  }
  
}
